import enUS from './en_US'

export default {
  tagsView: {
    refresh: 'refresh',
    close: 'close',
    closeOthers: 'closeOthers',
    closeAll: 'closeAll'
  },
  ...enUS,
  ETD: 'ETD',
  ETA: 'ETA',
  i18nDemo: {
    message: 'this is a english btn',
    btnDesc: 'english btn',
    messageBtn: 'click me,see message'
  },
  baseInfo: {
    seaport: {
      tabPort: {
        tabName: 'port'
      },
      tabEdiPort: {
        tabName: 'ediPort',
        shipCompany: 'Ship Company',
        originPortCode: 'Origin Port Code',
        currentPortCode: 'Current Port Code',
        shipCompanyCheck: 'Please select a shipping company!',
        originPortCodeCheck: 'Please select a port!',
        currentPortCodeCheck: 'Please enter 5-digit port code!'
      },
      tabAmsPort: {
        tabName: 'amsPort',
        amsPortMaintain: 'Ams Port Maintain',
        usNo: 'US NO',
        englishName: 'English Name',
        unNo: 'UN NO',
        country: 'Country',
        remark: 'Remark',
        usNoCheck: 'Please Enter The Correct Us No',
        englishNameCheck: 'English Name Cannot Be Empty.',
        unNoCheck: 'Please Enter The Correct UN No.',
        countryCheck: 'Country Cannot Be Empty.'
      }
    },
    city: {
      code: 'Code',
      chineseName: 'Chinese Name',
      englishName: 'English Name',
      locationCode: 'City Code',
      country: 'Country',
      addBaseCity: 'Add Base City',
      codeCheck: 'Code cannot be empty!',
      englishNameCheck: 'Englsih Name cannot be empty!',
      countryCheck: 'Please select a country!',
      lon: 'Lon',
      lat: 'Lat'
    },
    overseaWarehouse: {
      warehouseCode: 'Warehouse No',
      countryChineseName: 'Chinese Name',
      countryEnglishName: 'English Name',
      country: 'Country',
      province: 'Province',
      city: 'City',
      zipCode: 'Zip Code',
      address: 'Address',
      address1: 'Address 1',
      address2: 'Address 2',
      address3: 'Address 3',
      ifFba: 'Is Fba',
      entryRequirements: 'Entry Warehouse Requirements',
      warehouseAgeCalculationRules: 'Inventory Age Calculation Rules',
      warehouseAgeCalculationRulesEdit: 'Inventory Age Calculation Rules(Week)',
      btn: {
        newFbaWarehouse: 'Add FBA Warehouse',
        newOverseaWarehouse: 'Add Oversea Warehouse'
      },
      msg: {
        warehouseNoEmpty: 'Warehouse code cannot be empty',
        countryNoEmpty: 'Country cannot be empty',
        cityNoEmpty: 'City cannot be empty',
        zipCodeNoEmpty: 'Zip code cannot be empty',
        addressNoEmpty: 'Address cannot be empty',
        chineseNameNoEmpty: 'Chinese name cannot be empty',
        englishNameNoEmpty: 'English name cannot be empty',
        warehouseAgeCalculationRulesNoEmpty: 'Warehouse age calculation rules cannot be empty',
        unSelectFbaWarehouse: 'FBA warehouse not selected',
        canNotEditFbaWarehouse: 'Can Not Edit Amazon Warehouse',
        duplicateAddition: '{0} Already added, Cannot be added repeatedly',
        warehouseNoLen: 'The length of overseas warehouse code cannot exceed 16 digits'
      }
    },
    basicData: {
      continent: {
        code: 'Code',
        name: 'Name',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!'
      },
      region: {
        code: 'Code',
        name: 'Chinese Name',
        nameEnglish: 'English Name',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Chinese Name cannot be empty!'
      },
      mscService: {
        serviceCode: 'Service Code',
        serviceName: 'Service Name',
        serviceCodeCheck: 'Service Code cannot be empty!',
        serviceNameCheck: 'Service Name cannot be empty!'
      },
      network: {
        code: 'Network Code',
        name: 'Network Name',
        codeCheck: 'Network Code cannot be empty!',
        nameCheck: 'Network Name cannot be empty!'
      },
      currency: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        defaultFractionDigits: 'Currency Fraction Digits',
        symbol: 'Symbol',
        remarks: 'Remarks',
        addBaseCurrency: 'Add Base Currency',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!',
        defaultFractionDigitsCheck: 'Currency Fraction Digits cannot be empty!',
        carryRule: 'Currency carry rule',
        rounding: 'Rounding',
        truncation: 'Truncation'
      },
      eqType: {
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        remarks: 'Remark',
        addBaseEQType: 'Add Base EQType',
        codeCheck: 'Code cannot be empty!'
      },
      packing: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        englishName: 'English Name',
        chineseName: 'Chinese Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        position: 'Position',
        ediCode: 'EDI Code',
        addBasePacking: 'Add Base Packing',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!',
        positionCheck: 'Position cannot be empty!',
        userDefinedField: 'User Defined Field'
      },
      orderFormType: {
        code: 'Code',
        name: 'Name',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!'
      },
      cargoType: {
        code: 'Code',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        sea: 'For Sea',
        air: 'For Air',
        fbaSea: 'For FBA Sea',
        fbaAir: 'For FBA Air',
        fbaRailway: 'For Fba Railway',
        codeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!'
      },
      incoTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBaseIncoTerm: 'Add Base Inco Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      shippingTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBaseShippingTerm: 'Add Base Shipping Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!',
        defaultContainerLoadType: 'Default ContainerLoadType',
        defaultShow: 'Default Show',
        operationTypeTip: '※ After configuration, the transportation terms can be displayed by default in the corresponding main document split transportation terms column of the marine export business corresponding to the consolidation type'
      },
      paymentTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBasePaymentTerm: 'Add Base Payment Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      tradeTerm: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Chinese Name',
        localName: 'Local Name',
        englishName: 'English Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        remark: 'Remark',
        addBaseTradeTerm: 'Add Base Trade Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      priceAirService: {
        code: 'Code',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        codeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!'
      },
      portGroup: {
        portCode: 'Port Code',
        groupCode: 'Group Code',
        portCodeCheck: 'Port Code cannot be empty!',
        groupCodeCheck: 'Group Code cannot be empty!'
      },
      otherChargeItem: {
        chargeItemCode: 'Code',
        chineseName: 'Chinese Name',
        measure: 'Measure',
        defaultApPrice: 'Default Ap Price',
        remark: 'Remark',
        chargeWeight: 'Charge Weight',
        wt: 'WT',
        job: 'Job',
        chargeItemCodeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!'
      },
      customerType: {
        typeId: 'Level',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        typeIdCheck: 'Level cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!'
      },
      appraisalCategory: {
        serialNumber: 'Serial Number',
        serialNumberCheck: 'Serial Number cannot be empty!',
        code: 'code',
        codeCheck: 'code cannot be empty!',
        chineseName: 'Chinese Name',
        englishName: 'English Name',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!'
      },
      blMode: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        interchangeCode: 'Interchange Code',
        isoCode: 'ISO Code',
        blType: 'Bl Type',
        remark: 'Remark',
        addBaseBlMode: 'Add Bl Mode Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        interchangeCodeCheck: 'Interchange Code cannot be empty!',
        isoCodeCheck: 'ISO Code cannot be empty!'
      },
      cutomJobType: {
        serialNumber: 'Serial Number',
        code: 'Code',
        name: 'Name',
        localName: 'Local Name',
        englishName: 'English Name',
        type: 'Type',
        remarks: 'Remark',
        containerLoadType: 'Container Load Type',
        se: 'SeaExport',
        si: 'SeaImport',
        ae: 'AirExport',
        ai: 'AirImport',
        re: 'RailwayExport',
        addBaseBlMode: 'Add Base Trade Term',
        serialNumberCheck: 'Serial Number cannot be empty!',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!',
        typeCheck: 'Type cannot be empty!',
        interchangeCode: 'Interchange code',
        codeTips1: '*The code format is English and numbers, and the number of words is limited to 4 digits.',
        codeTips2: 'Code length exceeds the limit, please re-enter!',
        codeTips3: 'The code format is incorrect, please re-enter!',
        codeTips4: '*The code format is: English, numbers, and combinations, with a word limit of 10.'
      },
      chargeUnit: {
        codeCheck: 'Code cannot be empty!',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!',
        chargeUnitAndUnitCheck: 'Check at least one display for billing unit and company, please select!',
        businessTypeCheck: 'Check at least one display for shipping or air transportation or FBA shipping or FBA air transportation or FBA railway transportation, please select!',
        seaFreightAndAirFreightCheck: 'Check at least one display for shipping and air transportation, please select!'
      },
      dangerousGoods: {
        codeCheck: 'Please fill in the UN number'
      },
      cargoInformation: {
        codeCheck: 'Code cannot be empty',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!'
      },
      propulsionType: {
        codeCheck: 'Name cannot be empty!'
      },
      baseCustomsDeclarationType: {
        code: 'code',
        name: 'name',
        englishName: 'englishName',
        codeCheck: 'Code cannot be empty!',
        nameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!',
        codeTooLong: 'Column 【Code】 Is Too Long',
        nameTooLong: 'Column 【Name】 Is Too Long',
        englishNameTooLong: 'Column 【EnglishName】 Is Too Long',
        addBaseCustomsDeclarationType: 'Add Base Customs Declaration Type',
        isPlatform: 'Is Platform',
        PlatformTip: 'The newly added data on the platform cannot be modified！'
      },
      gpExplainTitle: {
        codeCheck: 'Code cannot be empty',
        chineseNameCheck: 'Chinese Name cannot be empty!',
        englishNameCheck: 'English Name cannot be empty!'
      }
    },
    airport: {
      addBasePort: 'Add Base Port',
      serialNumber: 'Serial Number',
      code: 'Code',
      chineseName: 'Chinese Name',
      englishName: 'English Name',
      interchangeCode: 'Interchange Code',
      isoCode: 'Iso Code',
      countryCode: 'Country Code',
      region: 'Region',
      requirement: 'Port Requirement',
      whetherToAdd: 'Whether To Add',
      portAdd: 'Port Add',
      portEdit: 'Port Edit',
      cityName: 'City Name',
      cityCode: 'City Code',
      codeCheck: 'Please Fill In The Correct Port Code',
      interchangeCodeCheck: 'Exchange Code Cannot Be Empty',
      isoCodeCheck: 'ISO Code Cannot Be Empty',
      englishNameCheck: 'English Name Cannot Be Empty'
    },
    operation: {
      operationType: 'Operation Type',
      lobType: 'Lob Type',
      code: 'Code',
      lob: 'Lob',
      operationRequirementType: 'Operation Type',
      contentDescription: 'Code/Content description',
      operationMaintain: 'Operation Maintain',
      remark: 'Remark',
      enterContentDescription: 'Please enter a code or description'
    },
    customsCommodityCode: {
      code: 'Code',
      commodityName: 'Commodity Name',
      mfnRate: 'Mfn Rate',
      generalRate: 'General Rate',
      vat: 'Vat',
      legalUnit: 'LegalUnit',
      mscCommodity: 'MscCommodity',
      secondUnit: 'SecondUnit',
      superviseMode: 'SuperviseMode',
      customsCommodityCodeMaintain: 'Customs Commodity Code Maintain',
      countryCode: 'Country Code',
      countryCodeCheck: 'Country Code Cannot Be Empty. ',
      codeCheck: 'Code Cannot Be Empty. ',
      commodityNameCheck: 'Commodity Name Cannot Be Empty.'
    },
    usCommodityCode: {
      systemCode: 'System code',
      tradeName: 'Trade name',
      productDescription: 'Product description',
      descriptionCode: 'Description code',
      customsTariff: 'customs tariff',
      additionalTaxRate056: '056 additional tax rate',
      including499AdditionalTaxRate: 'Including 499 additional tax rate',
      including501AdditionalTaxRate: 'Including 501 additional tax rate',
      chinaAdditionalTaxRate: 'China additional tax rate',
      chinaSurtaxTariff: "China's surtax tariff",
      chinaSurtaxClause: 'China surtax clause',
      enable: 'Enable',
      disable: 'Disable',
      chinaHongKongSurtaxTariff: 'Hong Kong Surcharge Tax Regulations',
      remark: 'Remark'
    },
    country: {
      serialNumber: 'Serial Number',
      code: 'Code',
      englishName: 'English Name',
      chineseName: 'Chinese Name',
      continent: 'Continent',
      interchangeCode: 'Tnterchange Code',
      isoCode: 'Iso Code',
      countryMaintain: 'Country Maintain'
    },
    rateManagement: {
      copyRate: 'Copy Rate',
      originalCurrency: 'Original Currency',
      benchmarkCurrency: 'Benchmark Currency',
      rate: 'Rate',
      effectiveMonth: 'Effective Month',
      currentMonth: 'current Month',
      baseCuurency: 'Benchmark Currency',
      currency: 'Original Currency',
      month: 'Effective Month',
      rateMaintain: 'Rate Maintain',
      currencyCheck: 'Please Enter The Original Currency!',
      rateCheck: 'Please Enter The Exchange Rate!',
      rateIsTooLong: 'Rate Is Too Long, Please Modify!',
      repeatCheck: 'Duplicate Configuration Appears, Please Modify!',
      repeatCheck2: 'Duplicate Configuration Appears of {0} to {1}, Please Modify!',
      copyRateMaintain: 'Copy Rate',
      copyCurrentMonthCheck: 'Cannot Copy The Data Of The Current Month, Please Select Another Month!',
      copyRowDataCheck: 'No Data For This Month.',
      copyRateSuccess: 'Copy Rate Successfully.',
      notFoundRate: 'Cannot Find The Exchange Rate Of Currency {0}, Please Maintain The Relevant Exchange Rate In Time!',
      setRateCacheRangeNote: 'Set the month range of exchange rate cache to 18-36 months',
      setRateCacheRange: 'Set exchange rate cache duration',
      setRateCacheRangePrefix: 'Cache month',
      setRateCacheRangeSuffix: 'months'
    },
    // 合作伙伴
    partner: {
      companyName: 'Company Name',
      companyType: 'Company Type',
      customerTypeId: 'Customer Level',
      remarks: 'Remarks',
      approvedState: 'Approved State',
      volume: 'Volume',
      cmpIdx: 'Number',
      shortName: 'Short Name',
      cnShortName: 'Code',
      region: 'Country',
      area: 'Area',
      chineseName: 'Chinese Name',
      englishName: 'English Name',
      contractStatus: 'Contract Status',
      branchId: 'Branch Company',
      approvedBy: 'Approved By',
      dateApproved: 'Date Approved',
      createBy: 'Create By',
      dateType: 'Date Type',
      controlSetting: 'Date type of credit control setting',
      creditDateType: 'Settlement Modes',
      blacklist: 'blacklist',
      cargoSource: 'Type of goods',
      receivableDeposit: 'Revenue&Expense Type',
      accountingPeriod: 'Accounting period',
      quota: 'quota',
      creditQuota: 'Credit control limit',
      creditCurrency: 'Credit controlled currency',
      supplierDirector: 'Supplier Director',
      dateCreated: 'Date Created',
      modifiedBy: 'Modified By',
      dateModified: 'Date Modified',
      isActive: 'Is Active',
      relateTenantUuid: 'Related Tenant Uuid',
      sales: 'Sales',
      freightVolume30: 'Freight Volumn 30',
      freightVolume60: 'Freight Volumn 60',
      freightVolume90: 'Freight Volumn 90',
      freightVolumeGt30: 'Freight Volumn greater than 90',
      // 基础信息
      basicInfo: {
        title: 'Basic Info',
        relatedBusinessType: 'Related Business Type',
        scac: 'SCAC',
        province: 'Province',
        city: 'City',
        district: 'District'
      }
    },
    // 收发通地址
    mailingAddress: {
      office: 'office',
      lobType: 'lob Type',
      partner: 'partner',
      podName: 'pod Name',
      shipperCode: 'shipper Code',
      shipperInfo: 'shipper Info',
      consigneeCode: 'consignee Code',
      consigneeInfo: 'consignee Info',
      notifyCode: 'notify Code',
      notifyInfo: 'notify Info',
      shipperName: 'shipper Name',
      consigneeName: 'consignee Name',
      notifyName: 'notify Name',
      partner1: 'partner',
      pod1: 'pod',
      formatManifestInfo: 'Format Manifest Info',
      shipper: 'shipper',
      shipperEnterpriseCode: 'shipper Enterprise Code',
      shortCode: 'short Code',
      enterpriseCode: 'enterprise Code',
      shipperEnterpriseName: 'shipper Enterprise Name',
      shipperAddress: 'shipper Address',
      cityName: 'city Name',
      provinceCode: 'province Code',
      provinceName: 'province Name',
      zipCode: 'postal Code',
      countryCode: 'country Code',
      aeoEnterpriseCode: 'aeo Enterprise Code',
      syncFormatInfoToOrder: 'Synchronize FormatInfo To Order',
      consignee: 'consignee',
      instructBill: 'instruct Bill',
      consigneeEnterpriseCode: 'consignee Enterprise Code',
      consigneeEnterpriseName: 'consignee Enterprise Name',
      consigneeAddress: 'consignee Address',
      consigneeSpecificContactsName: 'consignee Specific Contacts Name',
      consigneeSpecificContacts: 'consignee Specific Contacts',
      notify: 'notify',
      notifyEnterpriseCode: 'notify Enterprise Code',
      notifyEnterpriseName: 'notify Enterprise Name',
      notifyAddress: 'notify Address',
      shipperPhoneNumber: 'shipper Phone Number',
      shipperEmail: 'shipper Email',
      shipperFax: 'shipper Fax',
      consigneePhoneNumber: 'consignee Phone Number',
      consigneeEmail: 'consignee Email',
      consigneeFax: 'consignee Fax',
      consigneeSpecificPhoneNumber: 'consignee Specific Phone',
      consigneeSpecificEmail: 'consignee Specific Email',
      consigneeSpecificFax: 'consignee Specific Fax',
      notifyPhoneNumber: 'notify Phone Number',
      notifyEmail: 'notify Email',
      notifyFax: 'notify Fax',
      addMailingAddress: 'Add sys Bill Address',
      editMailingAddress: 'Edit sys Bill Address',
      validLobMsg: 'Please select lob type.',
      validInstructBill: 'Consignee selected instructBill mode, then notifyEnterpriseCode and notifyContacts both required.',
      fbaWarehouseCode: 'Amazon warehouse code',
      contactName: 'Contact name',
      province: 'Province',
      addr1: 'Address 1',
      addr2: 'Address 2',
      addr3: 'Address 3',
      eoriNo: 'Eori / enterprise number',
      taxNo: 'duty paragraph',
      ManifestFormatShipper: 'Manifest format shipper',
      TheManifestFormatConsignee: 'The manifest format consignee',
      ManifestFormatNotifier: 'Manifest Format Notifier'
    }
  },
  sysManage: { // 系统管理
    baseConfig: { // 基本配置
      triggerTypeManagement: { // 触发类型管理
        addTriggerType: 'AddTriggerType',
        editTriggerType: 'EditTriggerType',
        lookTriggerType: 'look Trigger Type',
        validFieldNameMsg: 'please input fieldName.',
        validFieldEnameMsg: 'please input fieldEname.',
        triggerType: 'triggerType',
        fieldCheckType: 'fieldCheckType',
        entityCode: 'entityCode',
        entityName: 'entityName',
        entityEname: 'entityEname',
        fieldCode: 'fieldCode',
        fieldName: 'fieldName',
        fieldEname: 'fieldEname',
        fieldCheckValue: 'fieldCheckValue',
        innerDateState: 'state comes from inner data',
        outerDateState: 'state comes from outer data',
        applySopNode: 'apply sop node',
        remark: '备注'
      },
      routeWareHouseConfiguration: { // 航线与仓库配置
        addRouteWareHouseMapping: 'AddRouteWareHouseMapping',
        editRouteWareHouseMapping: 'EditRouteWareHouseMapping',
        validRegionCodeMsg: 'please input regionCode.',
        validWarehouseMsg: 'please select warehouse.',
        regionCode: 'regionCode',
        warehouse: 'warehouse',
        remark: 'remark'
      },
      singleOnlineSetting: { // 海运在线对单设置
        branchId: 'branchId',
        fieldCode: 'fieldCode',
        fieldName: 'fieldName',
        fclEdit: 'isFclEdit',
        lclEdit: 'isLclEdit'
      }
    }
  },
  sysMonitor: { // 系统监控
    sopSendLog: {
      orderNo: 'orderNo',
      relationId: 'relationId',
      dateCreated: 'dateCreated',
      type: 'type',
      pushNode: 'pushNode',
      pushingChannel: 'pushingChannel',
      pushingResult: 'pushingResult',
      receivingUser: 'receivingUser',
      receivingTxt: 'receivingTxt',
      modifyDate: 'modifyDate',
      file: 'file'
    }
  },
  common: {
    defaultPlaceholder: 'Please input keyword',
    BeginDate: 'Valid From',
    EndDate: 'Valid Until',
    pagePer: 'Record/pp.',
    pleaseChoose: 'Please Choose',
    confirm: 'Confirm',
    reset: 'Reset',
    cancel: 'Cancel',
    tips: {
      fuzzySearch: 'Please input code, name and other fuzzy queries',
      fuzzyCodeSearch: 'Please input code fuzzy queries',
      fuzzyModelSearch: 'Please input model fuzzy queries',
      overseaWarehouseFuzzySearch: 'Please enter the overseas warehouse code fuzzy query',
      fuzzySearchForJudgment: 'Please enter serial number and judgment reason for fuzzy query',
      fuzzySearchForCustomEqType: 'Please enter the size and type of box for fuzzy query',
      hasOneAtleast: 'Please select at least one record',
      hasOneAtleastAudit: 'Please select at least one audited record',
      saveSuccess: 'Save successfully!',
      prompt: 'Prompt',
      cannotDeleteBranch: 'Cannot delete fee plan to create branch!',
      systemPrompt: 'System Prompt',
      confirmDelete: 'Are you sure to delete this record?',
      confirmCheck: 'Are you sure to check records?',
      confirmCancelCheck: 'Are you sure to cancel check records?',
      confirm: 'Confirm',
      deleteSuccess: 'Delete successfully!',
      editSuccess: 'Edit successfully!',
      deleteFail: 'Delete fail!',
      cancelDelete: 'Cancel Delete!',
      yes: 'Yes',
      no: 'No',
      repeatedlyTip: 'Repeatedly Tip',
      pleaseChoose: 'Please Choose',
      isAdded: 'Is Added',
      resetSuccess: 'Reset successfully!',
      warning: 'warning',
      branchSame: 'The Branch Company Of The Data Being Operated Does Not Belong To The Current Branch Or The Upper Branch!'
    },
    btn: {
      refresh: 'Refresh',
      query: 'Query',
      look: 'View',
      new: 'New',
      add: 'Add',
      edit: 'Edit',
      editAgain: 'Edit Again',
      delete: 'Delete',
      exportExcel: 'Export Excel',
      downLoadTemplate: 'DownLoad Template',
      save: 'Save',
      cancel: 'Cancel',
      ok: 'OK',
      confirm: 'Confirm',
      back: 'Back',
      audit: 'Audit',
      reject: 'Reject',
      reset: 'Reset',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      next: 'Next step',
      confirmUpdate: 'Confirm Update',
      enable: 'enable',
      disable: 'disable'
    },
    createBy: 'Create By',
    dateCreated: 'Date Created',
    modifiedBy: 'Modified By',
    dateModified: 'Date Modified'
  },
  // 常量
  constant: {
    all: 'All',
    yes: 'Yes',
    no: 'No',
    greaterThan: 'Greater Than',
    lessThan: 'Less Than',
    equal: 'Equal',
    email: 'Email',
    note: 'Note',
    enterpriseWechat: 'Enterprise Wechat',
    sop: {
      JOB_NO: 'Job No',
      CUSTOMER_ID: 'CUSTOMER',
      CUSTOMER_ID_CN: 'CUSTOMER',
      CUSTOMER_ID_US: 'CUSTOMER',
      CARRIER_CN: 'CARRIER',
      CARRIER_US: 'CARRIER',
      CARRIER_CODE: 'CARRIER',
      CARRIER_SHORT_NAME: 'CARRIER',
      DESTINATION_AGENT: 'Destination Agent',
      DESIGNATION_AGENT: 'Designation Agent',
      LOADING_PORT_CODE: 'POL',
      LOADING_PORT_CODE3: 'POL code',
      DESTINATION_PORT_CODE: 'POD',
      DESTINATION_PORT_CODE2: 'POD code',
      BARGE_POL: 'Port of departure for barges',
      VESSEL: 'vessel',
      VOYAGE: 'Voyage',
      BRANCH_VESSEL: 'Name of feeder barge',
      BRANCH_VOYAGE: 'Branch barge voyages',
      WAREHOUSE_NO: 'Warehouse No',
      SO_NO: 'SelectSoNo',
      MBL: 'MblNo2',
      HBL_NO: 'HB/L NO',
      ETD: 'ETD',
      ETA: 'ETA',
      ATD: 'ATD',
      ATA: 'ATA',
      CONSIGNEE_CODE: 'Consignee',
      CUSTOMER_REF_NO: 'Business reference number',
      USER_DEFINED_FIELD1: 'User Defined Field1',
      USER_DEFINED_FIELD2: 'User Defined Field2',
      USER_DEFINED_FIELD3: 'User Defined Field3',
      USER_DEFINED_FIELD4: 'User Defined Field4',
      ESTIMATED_SHIPPING_DATE: 'Estimated shipping date',
      CSR: 'CSR',
      CSR_PHONE: 'CSR PHONE',
      SINGLE_ADDRESS: 'single address',
      CUTOFF_TIME: 'cutoff time',
      EstimatedArrivalTime: 'Estimated arrival time',
      actualArrivalTime: 'Actual arrival time',
      PortDischargeTime: 'Port discharge time',
      ActualLiftingDate: 'Actual lifting time',
      ActualReturnTime: 'Actual return time',
      MBLTransportationClause: 'MBL Shipment Terms',
      HBLTransportationClause: 'HBL Shipment Terms',
      MasterBLFreightTerm: 'MBL Freight Terms',
      HBLFreightClause: 'HBL Freight Terms',
      MORE_DOOR_QUANTITY: 'Number of multiple doorpoints',
      ROUGH_WEIGHT: 'Multiple door point gross weight',
      MORE_DOOR_VOLUME: 'Multiportal volume',
      PACKAGING_TYPE: 'Packing type',
      SHIPPER_CODE: 'HBL Shipper Code',
      BUSINESS_MODEL: 'Business model',
      TICKET_RECEIPT: 'Ticket receipts',
      NO_LISTING: 'Container number',
      ESTIMATED_DELIVERY_DATE: 'Gate estimated delivery date',
      UNLOADING_WAY: 'Door unloading method',
      PO: 'PO',
      CNEE_CODE: 'HBL CNEE Code',
      ADDRESS: 'Door address',
      BASIC_NUMBER: 'Basic TAB-Number of items',
      BASIC_ROUGH_WEIGHT: 'Basic TAB-Gross weight',
      BASIC_VOLUME: 'Basic TAB-Volume',
      DELIVER_DATE: 'Deliver Date',
      ARRIVE_STORAGE_DATE: 'Arrive Storage Date',
      TRANS_DATE: 'Trans Date',
      CUSTOMER_REF_NO2: 'Business reference number',
      LOADING_PORT_CODE2: 'POL',
      CARRIER_ID: 'Airline Company',
      CARRIER_ID_CN: 'Airline Company',
      CARRIER_ID_US: 'Airline Company',
      VOYAGE_FLIGHT: 'Flight',
      ETD2: 'ETD',
      ETA2: 'ETA',
      WAREHOUSE_NO2: 'Warehouse No',
      QUANTITY: 'Number',
      WEIGHT: 'Weight',
      VOLUME: 'Volume',
      DOWNLOAD_URL: 'Pre-record Sheet Download Url',
      MBL2: 'MAWB NO',
      HAWB: 'HAWB NO',
      DISCHARGING_PORT: 'discharging port',
      DISCHARGING_PORT2: 'discharging port code',
      WAREHOUSE_DATA: 'warehouse data',
      STATUS_UPDATE_TIME: 'state update time',
      QUANTITY_CONTRACT: 'quantity contract',
      WEIGHT_CONTRACT: 'weight contract',
      CUBAGE_CONTRACT: 'cubage contract',
      TRUST_FROM_JOB: 'trust from job',
      RELATED_JOB: 'related job',
      BASIC_SHIPPER_CODE: 'baisc shipper code',
      BASIC_CONSIGNEE_CODE: 'basic consignee code',
      INCOTERMS: 'IncoTerms',
      CHARGE_WEIGHT: 'chargeWeight',
      PACKAGE: 'package',
      REMARK: 'remarks',
      POD: 'POD',
      LOADING_PORT_CODE4: 'POL code',

      MBLNO: 'MBL NO',
      CONTACT: 'contacts',
      AIR_LINE: 'transport line',
      TRANSPORT_TYPE: 'transport type',
      DEPARTURE_STATION: 'departure station',
      DEPARTURE_STATION_CODE: 'departure station code',
      DESTINATION_STATION: 'destination station',
      DESTINATION_STATION_CODE: 'destination station code',
      TRANSIT_STATION: 'transit station',
      TRANSIT_STATION_CODE: 'transit station code',
      PAYMENT_METHOD: 'payment method',
      TRACK_NO: 'tracking number',
      SHUTTLE: 'shuttle',
      TRAIN_NO: 'train no',
      QUANTITY_ACTUAL: 'quantity actual',
      WEIGHT_ACTUAL: 'weight actual',
      CUBAGE_ACTUAL: 'cubage actual',
      CARGO_ENGLISH_NAME: 'english name',
      SALES: 'sales',
      SALES_EMAIL: 'sales email',
      // 新增毛体重
      ACTUAL_PIECE: 'actual piece',
      ACTUAL_WEIGHT: 'actual weight',
      ACTUAL_VOLUME: 'actual volume',
      CUSTOMER_SERVICE: 'customer service',
      DOCUMENT: 'document',
      ROUTE_MANAGER: 'Route Manager',
      OVERSEAS_CUSTOMER_SERVICE: 'Overseas customer service',
      ROUTE_MANAGER_EMAIL: 'Route Manager Email',
      INTEGRATION_TYPE: 'Integration type',
      ROUTE_LEADER: 'Route leader',
      ROUTE_LEADER_EMAIL: 'Route leader Email',
      OPERATE: 'operate',
      PACKING: 'packing',
      PACKING_CN: 'Packaging (Chinese)',
      PACKING_US: 'Packaging (English)',
      TYPE_OF_GOODS: 'Type of goods',
      TYPE_OF_GOODS_CODE: 'Type of goods (code)',
      MAIN_PAYMENT_LOCATION: 'Main payment location',
      MARK: 'Mark',
      HS_NUMBER: 'HS number',
      CUSTOM_POSITION_1: 'Custom Position 1',
      CUSTOM_POSITION_2: 'Custom Position 2',
      TRANSIT_PORT: 'Transit Port',
      BOOKING_NUMBER: 'Booking number',
      SHIPPING_NUMBER: 'Shipping Company Appointment Number',
      BARGES_REMARKS: 'Notes on information of feeder barges',
      MBL_SHIPPER: 'MB/L shipper',
      MBL_CONSIGNEE: 'MB/L consignee',
      MBL_NOTIFIER: 'MB/L notifier'
    },
    nodeType: {
      lodingPort: 'LodingPort',
      transferPort: 'TransferPort',
      destinationPort: 'DestinationPort',
      warehousing: 'Warehousing',
      booking: 'Booking',
      entrust: 'Entrust',
      container: 'Container',
      distribution: 'Distribution',
      supplement: 'Supplement'
    },
    // 推送渠道
    pushingChannel: {
      all: 'all',
      email: 'email',
      msg: 'msg'
    },
    // sop类型
    sopTypes: {
      all: 'all',
      sopSend: 'sop send',
      innerSend: 'inner send'
    },
    // 推送结果
    pushResult: {
      all: 'all',
      success: 'success',
      fail: 'fail'
    },
    // 系统常量
    systemConstants: {
      SE: 'SeaExport',
      SI: 'SeaImport',
      AE: 'AirExport',
      AI: 'AirImport',
      RE: 'RailwayExport',
      RI: 'RailwayImport',
      RB: 'RailwayBusiness',
      IE: 'Integrate Job',
      FBASE: 'FBA Sea',
      FBAAE: 'FBA Air',
      FBARE: 'FBA Railway'
    },
    // 提单流水号类型
    BillType: {
      MBL: 'MBL',
      HBL: 'HBL'
    },
    // 进口业务常量
    importConstants: {
      FCL: 'FCL',
      LCL: 'LCL',
      CON: 'Consolidation',
      POJ: 'Project',
      PVE: 'Personal Items',
      ECL: 'Entrust The LCL',
      BULK: 'BULK',
      CONSOLE: 'Console',
      DIRECT: 'Direct',
      BACK_TO_BACK: 'Back To Back'
    },
    // 空运出口常量
    airExportConstants: {
      CONSOLE: 'Console',
      DIRECT: 'Direct',
      BACK_TO_BACK: 'Back To Back'
    },
    // 海运出口常量
    seaExportConstants: {
      CONTRACT_STATE_NO: 'No Contract',
      CONTRACT_STATE_OUT_OF_DATE: 'Out of date',
      CONTRACT_STATE_SIGNED: 'Contract Signed'
    },
    templateRuleName: {
      CUSTOMER_CN_NAME: 'Customer Chinese Name',
      CUSTOMER_SHORT_NAME: 'Customer Short Name',
      SETTLEMENT_CN_NAME: 'Settlement Chinese Name',
      SETTLEMENT_SHORT_NAME: 'Settlement Short Name',
      BOOKING_AGENT_CN_NAME: 'Booking Agent Chinese Name',
      BOOKING_AGENT_SHORT_NAME: 'Booking Agent Short Name',
      LOB_NO: 'Lob NO',
      MBL_NO: 'MBL NO',
      HBL_NO: 'HBL NO',
      REF_NO: 'Ref NO',
      BILL_NO: 'Bill NO',
      BILL_PAYMENT_NO: 'Bill payment NO',
      WAREHOUSE_NO: 'Warehouse NO',
      PONO: 'Project NO',
      CUSTOMER_REF_NO: 'Customer Reference NO',
      PLATE_NUMBER_DOOR: 'License plate number (current door point)',
      PLATE_NUMBER_DEST: 'License plate number (current destination)',
      CARRIER_CN_NAME: 'Carrier Chinese Name',
      CARRIER_SHORT_NAME: 'Carrier Short Name',
      ETD: 'ETD',
      DESTINATION_PORT_CODE: 'Destination Port',
      DESTINATION_PORT_CODE_CODE: 'Destination Port Code'
    },
    genDocCondition: {
      FormalHbl: 'Formal HBL'
    },
    buttonName: {
      FormalHbl: 'Formal HBL'
    }

  },
  // 枚举参数
  parameter: {
    // 集装箱装载类型
    containerLoadType: {
      FCL: 'FCL',
      LCL: 'LCL',
      BB: 'Break Bulk',
      BC: 'Buyer Consol',
      BULK: 'BULK',
      SPA: 'Special'
    },
    // 合作伙伴服务项目
    partnerServiceItem: {
      ALL: 'ALL',
      CUSTOMER: 'CUSTOMER',
      BOOKING_AGENT: 'BOOKING_AGENT',
      OVERSEA_AGENT: 'OVERSEA_AGENT',
      DESIGNATION_AGENT: 'DESIGNATION_AGENT',
      LOCAL: 'LOCAL',
      SETTLEMENT_AGENT: 'SETTLEMENT_AGENT',
      SEA_CMP: 'SEA_CMP',
      AIR_CMP: 'AIR_CMP',
      SEA_CMP_AGENT: 'SEA_CMP_AGENT',
      CUSTOMS_BROKER: 'CUSTOMS_BROKER',
      TRUCK_CMP: 'TRUCK_CMP',
      WAREHOUSE: 'WAREHOUSE',
      GLOBAL: 'GLOBAL',
      SHIPPER: 'SHIPPER',
      CONSIGNEE: 'CONSIGNEE',
      NOTIFY: 'NOTIFY',
      PORT_AGENT: 'PORT_AGENT',
      FORWARDING_AGENT: 'FORWARDING_AGENT',
      LOADINGPLACE_COMPANY: 'LOADINGPLACE_COMPANY',
      SIGNBILLPLACE_COMPANY: 'SIGNBILLPLACE_COMPANY',
      DISCHARGEPORT_COMPANY: 'DISCHARGEPORT_COMPANY',
      DESTINATIONPORT_COMPANY: 'DESTINATIONPORT_COMPANY',
      OTHER: 'OTHER'
    },
    // 角色类型
    roleType: {
      SALES_TYPE: 'sales',
      CSR_TYPE: 'csr',
      DOC_TYPE: 'doc',
      OVERSEAOP_TYPE: 'overseaOp',
      SALES_OF_GOODS: 'salesOfGoods'
    }
  },
  advanceSearchForm: { // 高级查询组件
    ...enUS,
    advSearchBtn: 'adv search',
    quickSearch: 'Quick search',
    more: 'more',
    Equal: 'Equal',
    Greater: 'Greater',
    Less: 'Less',
    Unequal: 'Unequal',
    Like: 'Like',
    Not_Like: 'Not Like',
    In: 'In',
    Range: 'Range',
    Batch: 'Batch',
    BatchExclude: 'Batch Exclude',
    Regexp: 'Regexp',
    Not_In: 'Not In',
    Is_Not_Null: 'Is Not Null',
    Is_Null: 'Is Null',
    Is_It_Empty: 'Is It Empty',
    Date_Item: 'Shortcut Item',
    customer: {
      level: 'level',
      chineseName: 'chineseName',
      status: 'status'
    },
    bookingNew: { // 海运订舱极速版
      destinationCountry: 'Destination Country',
      hblCheckingStatus: 'HBL Checking Status',
      hblBlType: 'HBL B/L Way',
      hblBillOfLadingNumber: 'HBL Serial No',
      hblReleasingStatus: 'HBL Releasing Status',
      hblBlType2: 'HBL B/L Type',
      mblCheckingStatus: 'MBL Checking Status',
      mblBlType: 'MBL B/L Way',
      mblBillOfLadingNumber: 'MBL Serial No',
      overseaCustomerService: 'Oversea Customer Service',
      customerLevel: 'Customer Level',
      isSignContract: 'Is Sign Contract',
      userDefinedField1: 'User Defined Field1',
      userDefinedField2: 'User Defined Field2',
      userDefinedField3: 'User Defined Field3',
      opOffice: 'Operate Office',
      salesOffice: 'Sales Office',
      bookingAgentIsNull: 'Booking Agent Is Null'
    },
    shortcut: 'shortcut',
    daterange: 'range',
    lt: 'less',
    gt: 'gt',
    eq: 'equal',
    notEq: 'not equal',
    like: 'like',
    draft: 'draft',
    commit: 'commit',
    check: 'check',
    createDate: 'createDate',
    nowWeek: 'nowWeek',
    preWeek: 'preWeek',
    nextWeek: 'nextWeek',
    nowMonth: 'nowMonth',
    preMonth: 'preMonth',
    nextMonth: 'nextMonth',
    doubleClickToSelect: 'Double click to select',
    fitAll: 'Fit all',
    fitAny: 'Fit any'
  },
  route: {
    dashboard: 'Dashboard',
    baseInfo: 'Information',
    airport: 'airport',
    airlineCode: 'Airline Code',
    seaport: 'seaport',
    operationRequirementDescribe: 'OperationRequirementDescribe',
    city: 'City',
    basicData: 'BasicData',
    customsCommodityCode: 'CustomsCommodityCode',
    usCommodityCode: 'US Commodity Code',
    country: 'Country',
    rateManagement: 'Rate Management',
    chargeService: 'Charge Service',
    costPlan: 'Cost Plan',
    guarantee: 'Guarantee',
    payService: 'Pay Service',
    partner: 'Partner',
    mailingAddress: 'MailingAddress',
    seaPortRequirement: 'SeaPortRequirement',
    airPortRequirement: 'AirPortRequirement',
    partnerInformationImport: 'PartnerInformationImport',
    seaExport: 'SeaExport',
    bookingNew: 'BookingNew',
    ProjectManage: 'ProjectManage',
    project: 'Project',
    seaImport: 'SeaImport',
    airExportBooking: 'Air Booking',
    airImportBooking: 'Air Operations',
    railwayExport: 'Railway Operations',
    seaImportBooking: 'Shipping Operations',
    integratedJob: 'Integrated logistics',
    remoteBooking: 'Remote booking',
    prediction: 'prediction',
    preBooking: 'Pre booking',
    preOrder: 'Order Prequalification'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    github: 'Github',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    username: 'Username',
    password: 'Password',
    any: 'any'
  },
  act: {
    billing: {
      pleaseSelectBilling: 'Please Select Bill!',
      hasConfirmed: '[{0}]Bill Has Confirmed!',
      hasReviewed: '[{0}]Bill Has Reviewed!',
      hasBillingGroup: '【{0}】The Bill Has Been Reconciled!',
      hasInvoice: '【{0}】The Bill Has Been Invoiced!',
      hasWriteOff: '【{0}】The Bill Has Been Write Off!',
      confirmDelete: 'Are You Sure To Delete These {0} bills ?',
      noConfirmBill: 'There Are No Bills To Confirm!',
      noRecheckBill: 'There Are No Bills To Recheck!',
      noCancelRecheckBill: 'There Are No Bills To Cancel Recheck!',
      batchConfirmBill: 'Are You Sure You Want To Confirm These {0} Bills In Batch?',
      batchRecheckBill: 'Are You Sure You Want To Recheck These {0} Bills In Batch?',
      noCancelConfirmBill: 'No Bills To Cancel Confirmation!',
      confirmCancelBill: 'Are You Sure You Want To Cancel The Confirmation Of These {0} Bills?',
      cancelRecheckBill: 'Are You Sure You Want To Cancel The Recheck Of These {0} Bills?',
      sameSettlementAgent: 'Billing Agent Must Be The Same!',
      hasBillingGroupNo: 'Account Statement Number Has Been Created!',
      noBillToBillingGroup: 'There Is No Bill To Be Account Statement!',
      confirmSuccess: 'Confirm Success!',
      recheckSuccess: 'Recheck Success!',
      cancelConfirmSuccess: 'Cancel Confirmation Succeeded!',
      cancelRecheckSuccess: 'Cancel Recheck Succeeded!',
      reconciliationAmountNotSupport: 'The Reconciliation Amount You Entered Is Unreasonable',
      overseaHasPushed: '【{0}】The bill has been sent and cannot be deleted.',
      advDeleteConfirmTitle: 'The collection and advance payment bill has been pushed to Kingdee. Please ensure the corresponding document has been deleted in Kingdee before deletion.'
    },
    billingGroup: {
      hasConfirmed: '【{0}】Account Statement Has Confirmed!',
      hasReviewed: '【{0}】Statement reviewed!',
      confirmDelete: 'Are You Sure To Delete The {0} Statements?',
      billingNotNull: 'The Bills Can Not Null!',
      canNotRemoveAllBills: 'You Can Not Remove All Bills!',
      settlementAgentNotNull: 'Settlement Agent Of Bill [{0}] Cannot Be Empty!',
      settlementAgentAndAccountCanNotSame: 'The Settlement Agent Of The Bill [{0}] Is Inconsistent With The Settlement Object Of The Statement. Please Remove The Bill And Save It!',
      validateAp: 'When The Revenue And Expenditure Type Is A/R, The Total Amount Of A/R Bill Cannot Be Less Than The Total Amount Of A/P Bill!',
      validateAr: 'When The Revenue And Expenditure Type Is A/P, The Total Amount of A/P Bill Cannot Be Less Than The Total Amount Of A/R Bill!',
      selectedBillingGroup: 'Please Select BillGroup!',
      batchConfirmBillGroup: 'Are You Sure You Want To Confirm These {0} BillGroups In Batch?',
      batchConfirmBill: 'Whether the billing status is refreshed to confirmed?',
      noRecheckBillGroup: 'There are no reverenable statements！',
      batchRecheckBillGroup: 'Are you sure you want to review these {0} statements？',
      batchCancelRecheckBillGroup: 'Are you sure you want to cancel reviewing these {0} statements？',
      noCancelRecheckBillGroup: 'There are no statements that can be cancelled for review！',
      noCancelConfirmBillGroup: 'The statement has been reviewed and cannot be unconfirmed!'
    }
  },
  grid: {
    resetSort: 'Reset Sort',
    restColumns: 'Rest Columns',
    autoSizeColumns: 'Auto Size All Columns',
    pinLeftAll: 'Pin Left Columns',
    subtotal: 'Subtotal',
    groupedSubtotal: 'Grouped Subtotal',
    summaryMode: 'Summary Mode',
    count: 'Count',
    sum: 'Sum'
  }
}
// agGrid表格
export const i18n_ag_grid = {
  // Set Filter
  selectAll: '(Select All)',
  selectAllSearchResults: '(Select All Search Results)',
  searchOoo: 'Search...',
  blanks: '(Blanks)',
  noMatches: 'No matches',

  // Number Filter & Text Filter
  filterOoo: 'Filter...',
  equals: 'Equals',
  notEqual: 'Not equal',
  empty: 'Choose One',

  // Number Filter
  lessThan: 'Less than',
  greaterThan: 'Greater than',
  lessThanOrEqual: 'Less than or equal',
  greaterThanOrEqual: 'Greater than or equal',
  inRange: 'In range',
  inRangeStart: 'to',
  inRangeEnd: 'from',

  // Text Filter
  contains: 'Contains',
  notContains: 'Not contains',
  startsWith: 'Starts with',
  endsWith: 'Ends with',

  // Date Filter
  dateFormatOoo: 'yyyy-mm-dd',

  // Filter Conditions
  andCondition: 'AND',
  orCondition: 'OR',

  // Filter Buttons
  applyFilter: 'Apply',
  resetFilter: 'Reset',
  clearFilter: 'Clear',
  cancelFilter: 'Cancel',

  // Filter Titles
  textFilter: 'Text Filter',
  numberFilter: 'Number Filter',
  dateFilter: 'Date Filter',
  setFilter: 'Set Filter',

  // Side Bar
  columns: 'Columns',
  filters: 'Filters',

  // columns tool panel
  pivotMode: 'Pivot Mode',
  groups: 'Row Groups',
  rowGroupColumnsEmptyMessage: 'Drag here to set row groups(Current page)',
  values: 'Values',
  valueColumnsEmptyMessage: 'Drag here to aggregate',
  pivots: 'Column Labels',
  pivotColumnsEmptyMessage: 'Drag here to set column labels',

  // Header of the Default Group Column
  group: 'Group',

  // Other
  loadingOoo: 'Loading...',
  noRowsToShow: 'No results found.',
  enabled: 'Enabled',

  // Menu
  pinColumn: 'Pin Column',
  pinLeft: 'Pin Left',
  pinRight: 'Pin Right',
  noPin: 'No Pin',
  valueAggregation: 'Value Aggregation',
  autosizeThiscolumn: 'Autosize This Column',
  autosizeAllColumns: 'Autosize All Columns',
  groupBy: 'Group by',
  ungroupBy: 'Un-Group by',
  resetColumns: 'Reset Columns',
  expandAll: 'Expand All',
  collapseAll: 'Close All',
  copy: 'Copy',
  ctrlC: 'Ctrl+C',
  copyWithHeaders: 'Copy With Headers',
  paste: 'Paste',
  ctrlV: 'Ctrl+V',
  export: 'Export',
  csvExport: 'CSV Export',
  excelExport: 'Excel Export',

  // Enterprise Menu Aggregation and Status Bar
  sum: 'Sum',
  min: 'Min',
  max: 'Max',
  none: 'None',
  count: 'Count',
  avg: 'Average',
  filteredRows: 'Filtered',
  selectedRows: 'Selected',
  totalRows: 'Total Rows',
  totalAndFilteredRows: 'Rows',
  more: 'More',
  to: 'to',
  of: 'of',
  page: 'Page',
  nextPage: 'Next Page',
  lastPage: 'Last Page',
  firstPage: 'First Page',
  previousPage: 'Previous Page',

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
  pivotChart: 'Pivot Chart',
  chartRange: 'Chart Range',

  columnChart: 'Column',
  groupedColumn: 'Grouped',
  stackedColumn: 'Stacked',
  normalizedColumn: '100% Stacked',

  barChart: 'Bar',
  groupedBar: 'Grouped',
  stackedBar: 'Stacked',
  normalizedBar: '100% Stacked',

  pieChart: 'Pie',
  pie: 'Pie',
  doughnut: 'Doughnut',

  line: 'Line',

  xyChart: 'X Y (Scatter)',
  scatter: 'Scatter',
  bubble: 'Bubble',

  areaChart: 'Area',
  area: 'Area',
  stackedArea: 'Stacked',
  normalizedArea: '100% Stacked',

  histogramChart: 'Histogram',

  // Charts
  pivotChartTitle: 'Pivot Chart',
  rangeChartTitle: 'Range Chart',
  settings: 'Settings',
  data: 'Data',
  format: 'Format',
  categories: 'Categories',
  defaultCategory: '(None)',
  series: 'Series',
  xyValues: 'X Y Values',
  paired: 'Paired Mode',
  axis: 'Axis',
  navigator: 'Navigator',
  color: 'Color',
  thickness: 'Thickness',
  xType: 'X Type',
  automatic: 'Automatic',
  category: 'Category',
  number: 'Number',
  time: 'Time',
  xRotation: 'X Rotation',
  yRotation: 'Y Rotation',
  ticks: 'Ticks',
  width: 'Width',
  height: 'Height',
  length: 'Length',
  padding: 'Padding',
  spacing: 'Spacing',
  chart: 'Chart',
  title: 'Title',
  titlePlaceholder: 'Chart title - double click to edit',
  background: 'Background',
  font: 'Font',
  top: 'Top',
  right: 'Right',
  bottom: 'Bottom',
  left: 'Left',
  labels: 'Labels',
  size: 'Size',
  minSize: 'Minimum Size',
  maxSize: 'Maximum Size',
  legend: 'Legend',
  position: 'Position',
  markerSize: 'Marker Size',
  markerStroke: 'Marker Stroke',
  markerPadding: 'Marker Padding',
  itemSpacing: 'Item Spacing',
  itemPaddingX: 'Item Padding X',
  itemPaddingY: 'Item Padding Y',
  layoutHorizontalSpacing: 'Horizontal Spacing',
  layoutVerticalSpacing: 'Vertical Spacing',
  strokeWidth: 'Stroke Width',
  offset: 'Offset',
  offsets: 'Offsets',
  tooltips: 'Tooltips',
  callout: 'Callout',
  markers: 'Markers',
  shadow: 'Shadow',
  blur: 'Blur',
  xOffset: 'X Offset',
  yOffset: 'Y Offset',
  lineWidth: 'Line Width',
  normal: 'Normal',
  bold: 'Bold',
  italic: 'Italic',
  boldItalic: 'Bold Italic',
  predefined: 'Predefined',
  fillOpacity: 'Fill Opacity',
  strokeOpacity: 'Line Opacity',
  histogramBinCount: 'Bin count',
  columnGroup: 'Column',
  barGroup: 'Bar',
  pieGroup: 'Pie',
  lineGroup: 'Line',
  scatterGroup: 'X Y (Scatter)',
  areaGroup: 'Area',
  histogramGroup: 'Histogram',
  groupedColumnTooltip: 'Grouped',
  stackedColumnTooltip: 'Stacked',
  normalizedColumnTooltip: '100% Stacked',
  groupedBarTooltip: 'Grouped',
  stackedBarTooltip: 'Stacked',
  normalizedBarTooltip: '100% Stacked',
  pieTooltip: 'Pie',
  doughnutTooltip: 'Doughnut',
  lineTooltip: 'Line',
  groupedAreaTooltip: 'Area',
  stackedAreaTooltip: 'Stacked',
  normalizedAreaTooltip: '100% Stacked',
  scatterTooltip: 'Scatter',
  bubbleTooltip: 'Bubble',
  histogramTooltip: 'Histogram',
  noDataToChart: 'No data available to be charted.',
  pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
  chartSettingsToolbarTooltip: 'Menu',
  chartLinkToolbarTooltip: 'Linked to Grid',
  chartUnlinkToolbarTooltip: 'Unlinked from Grid',
  chartDownloadToolbarTooltip: 'Download Chart',

  // ARIA
  ariaHidden: 'hidden',
  ariaVisible: 'visible',
  ariaChecked: 'checked',
  ariaUnchecked: 'unchecked',
  ariaIndeterminate: 'indeterminate',
  ariaColumnSelectAll: 'Toggle Select All Columns',
  ariaInputEditor: 'Input Editor',
  ariaDateFilterInput: 'Date Filter Input',
  ariaFilterInput: 'Filter Input',
  ariaFilterColumnsInput: 'Filter Columns Input',
  ariaFilterValue: 'Filter Value',
  ariaFilterFromValue: 'Filter from value',
  ariaFilterToValue: 'Filter to value',
  ariaFilteringOperator: 'Filtering Operator',
  ariaColumnToggleVisibility: 'column toggle visibility',
  ariaColumnGroupToggleVisibility: 'column group toggle visibility',
  ariaRowSelect: 'Press SPACE to select this row',
  ariaRowDeselect: 'Press SPACE to deselect this row',
  ariaRowToggleSelection: 'Press Space to toggle row selection',
  ariaRowSelectAll: 'Press Space to toggle all rows selection',
  ariaSearch: 'Search',
  ariaSearchFilterValues: 'Search filter values'
}
